export default "__VITE_PUBLIC_ASSET__20824ec5__"